export default `
District,Party,Surname,AB68,AB215,AB787,AB1398,SB8,SB9,SB10,SB290,SB477,SB478
4,(D),Aguiar-Curry,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
31,(D),Arambula,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
16,(D),Bauer-Kahan,Aye,NVR,Aye,NVR,NVR,No,No,Aye,Aye,Aye
37,(D),Bennett,Aye,Aye,Aye,Aye,Aye,NVR,NVR,NVR,Aye,NVR
24,(D),Berman,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
5,(R),Bigelow,Aye,Aye,Aye,No,NVR,No,NVR,Aye,Aye,No
50,(D),Bloom,Aye,Aye,Aye,Aye,Aye,No,No,Aye,Aye,Aye
76,(D),Boerner Horvath,Aye,No,Aye,No,No,No,No,No,Aye,No
18,(D),Bonta,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
54,(D),Bryan,Aye,Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,Aye
62,(D),Burke,Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,Aye,Aye
57,(D),Calderon,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
51,(D),Carrillo,Aye,NVR,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
60,(D),Cervantes,Aye,Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,Aye
49,(D),Chau,Aye,Aye,Aye,Aye,Aye,NVR,Aye,Aye,Aye,Aye
55,(R),Chen,Aye,Aye,Aye,No,Aye,NVR,NVR,Aye,Aye,NVR
17,(D),Chiu,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
68,(R),Choi,Aye,NVR,Aye,No,Aye,NVR,NVR,Aye,Aye,No
8,(D),Cooley,NVR,Aye,NVR,NVR,Aye,Aye,Aye,Aye,Aye,Aye
9,(D),Cooper,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
35,(R),Cunningham,Aye,Aye,Aye,No,Aye,NVR,Aye,Aye,Aye,Aye
1,(R),Dahle,Aye,Aye,Aye,No,Aye,Aye,Aye,Aye,Aye,No
69,(D),Daly,Aye,Aye,Aye,Aye,Aye,No,NVR,Aye,Aye,Aye
73,(R),Davies,Aye,No,Aye,No,Aye,No,NVR,NVR,Aye,No
12,(R),Flora,Aye,Aye,Aye,No,Aye,Aye,Aye,Aye,Aye,NVR
34,(R),Fong,Aye,Aye,Aye,No,Aye,Aye,Aye,Aye,Aye,No
11,(D),Frazier,Aye,NVR,Aye,Aye,Aye,No,No,NVR,NVR,NVR
43,(D),Friedman,Aye,Aye,Aye,Aye,Aye,No,NVR,Aye,Aye,Aye
45,(D),Gabriel,Aye,Aye,Aye,Aye,Aye,No,Aye,Aye,Aye,Aye
3,(R),Gallagher,Aye,NVR,Aye,No,Aye,Aye,NVR,Aye,NVR,Aye
58,(D),Garcia (Christina),Aye,Aye,Aye,Aye,Aye,Aye,NVR,Aye,Aye,Aye
56,(D),Garcia (Eduardo),Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
64,(D),Gipson,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
80,(D),Gonzalez,Aye,NVR,Aye,Aye,NVR,Aye,Aye,Aye,Aye,Aye
21,(D),Gray,Aye,Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,NVR
14,(D),Grayson,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
41,(D),Holden,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
44,(D),Irwin,Aye,Aye,Aye,Aye,NVR,No,Aye,Aye,Aye,NVR
59,(D),Jones-Sawyer,Aye,Aye,Aye,Aye,Aye,Aye,NVR,Aye,Aye,Aye
27,(D),Kalra,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
6,(R),Kiley,Aye,NVR,Aye,No,Aye,NVR,Aye,Aye,Aye,NVR
36,(R),Lackey,Aye,Aye,Aye,No,Aye,Aye,Aye,Aye,Aye,No
25,(D),Lee,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
10,(D),Levine,Aye,No,Aye,Aye,Aye,No,Aye,Aye,Aye,Aye
28,(D),Low,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,NVR,Aye
77,(D),Maienschein,Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,Aye,Aye
26,(R),Mathis,Aye,NVR,Aye,No,NVR,Aye,NVR,NVR,Aye,NVR
42,(I),Mayes,Aye,Aye,Aye,NVR,Aye,Aye,Aye,Aye,Aye,NVR
7,(D),McCarty,Aye,Aye,Aye,Aye,Aye,NVR,NVR,NVR,Aye,Aye
61,(D),Medina,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
22,(D),Mullin,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
66,(D),Muratsuchi,NVR,NVR,Aye,NVR,NVR,No,No,NVR,NVR,No
46,(D),Nazarian,Aye,NVR,Aye,Aye,NVR,No,No,Aye,Aye,Aye
72,(R),Nguyen,Aye,No,Aye,No,NVR,NVR,NVR,NVR,NVR,No
70,(D),O'Donnell,Aye,Aye,Aye,Aye,Aye,No,No,NVR,Aye,NVR
23,(R),Patterson,Aye,Aye,Aye,No,NVR,NVR,Aye,Aye,Aye,No
74,(D),Petrie-Norris,Aye,NVR,Aye,NVR,NVR,No,No,Aye,Aye,Aye
20,(D),Quirk,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
65,(D),Quirk-Silva,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
40,(D),Ramos,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
63,(D),Rendon,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,NVR,Aye
47,(D),Reyes,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
39,(D),Rivas (Luz),Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,Aye,Aye
30,(D),Rivas (Robert),Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
52,(D),Rodriguez,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
48,(D),Rubio,Aye,Aye,Aye,Aye,Aye,NVR,Aye,Aye,Aye,Aye
32,(D),Salas,Aye,Aye,Aye,Aye,Aye,Aye,No,Aye,Aye,Aye
53,(D),Santiago,Aye,Aye,Aye,Aye,Aye,NVR,NVR,Aye,Aye,Aye
67,(R),Seyarto,Aye,NVR,Aye,No,NVR,No,No,Aye,NVR,No
33,(R),Smith,Aye,NVR,Aye,No,Aye,No,NVR,Aye,No,No
29,(D),Stone,Aye,Aye,Aye,Aye,Aye,Aye,No,Aye,Aye,Aye
19,(D),Ting,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
38,(R),Valladares,Aye,Aye,Aye,No,Aye,Aye,NVR,NVR,Aye,No
13,(D),Villapudua,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
71,(R),Voepel,Aye,Aye,Aye,No,Aye,No,No,Aye,Aye,Aye
75,(R),Waldron,Aye,No,Aye,No,Aye,No,NVR,Aye,Aye,No
78,(D),Ward,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
79,(D),Weber,Aye,NVR,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
15,(D),Wicks,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
2,(D),Wood,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye,Aye
`
